import React from 'react';
import { useDispatch } from 'react-redux';

import { ResponsiveDialog, useFilters, useSettings, useUserData, Utils } from 'app/main/components';
import AddRowsFilterDialog from 'app/main/modules/components/AddRowsFilterDialog';
import AddRowsResultDialog from 'app/main/modules/components/AddRowsResultDialog';
import CompaniesListItem from 'app/main/modules/companies/CompaniesListItem';
import PeopleListItem from 'app/main/modules/people/PeopleListItem';

interface MarketingActionsRowsAddFilterDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	table: string;
	maacUid: string;
	updateRefresh: VoidFunction;
}

const defaultFilters = [
	{ filt_field: 'comp_deleted', filt_clause: 'not_equal', filt_value: 1 },
	{ filt_field: 'peop_deleted', filt_clause: 'not_equal', filt_value: 1 }
];

export default function MarketingActionsRowsAddFilterDialog(props: MarketingActionsRowsAddFilterDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const { filters, currentFilters, setCurrentFilters, handleFiltersClear, handleFilterChange, handleFiltersApply } =
		useFilters({ module: props.table, defaultFilters });

	const [showResultsDialog, setShowResultsDialog] = React.useState(false);

	const closeDialog = () => {
		handleFiltersClear();
		props.switchOpenDialog();
		setShowResultsDialog(false);
	};

	const showResults = () => {
		handleFiltersApply();
		setShowResultsDialog(true);
	};

	const addRows = () => {
		Utils.executeStored({
			action: 'st_marketingactions_rows_add_multiple',
			dispatch,
			data: {
				marw_maac_uid: props.maacUid,
				marw_user_created_uid: userData.user_uid,
				marw_table: props.table,
				filters
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				closeDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg" scroll="body">
			{!showResultsDialog ? (
				<AddRowsFilterDialog
					title={t(`MAAC_SECTION_ADD_${props.table}_TITLE`)}
					module={props.table}
					defaultFilters={defaultFilters}
					currentFilters={currentFilters}
					setCurrentFilters={setCurrentFilters}
					handleFilterChange={handleFilterChange}
					showResults={showResults}
					closeDialog={closeDialog}
				/>
			) : (
				<AddRowsResultDialog
					title={t('MAAC_DIALOG_TITLE_ADD_RESULT')}
					module={props.table}
					itemLayout={props.table === 'companies' ? CompaniesListItem : PeopleListItem}
					defaultFilters={[
						...filters,
						{
							filt_field: 'marw_table',
							filt_clause: 'equals',
							filt_value: props.table
						}
					]}
					addRows={addRows}
					goBack={() => setShowResultsDialog(false)}
				/>
			)}
		</ResponsiveDialog>
	);
}
